var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "modal"
  }, [_c('section', {
    staticClass: "modal__inner"
  }, [_c('button', {
    staticClass: "modal__close",
    on: {
      "click": function ($event) {
        return _setup.emit('close-modal');
      }
    }
  }, [_vm._v("×")]), _vm.status === 'ok' ? [_vm._t("ok_text"), _c('div', {
    staticClass: "modal__buttons"
  }, [_c('button', {
    staticClass: "modal__button return_ok",
    on: {
      "click": function ($event) {
        return _setup.emit('close-modal');
      }
    }
  }, [_vm._v(" OK ")])])] : _vm.status === 'ng' ? [_vm._t("ng_text"), _c('div', {
    staticClass: "modal__buttons"
  }, [_c('button', {
    staticClass: "modal__button return_ng",
    on: {
      "click": function ($event) {
        return _setup.emit('close-modal');
      }
    }
  }, [_vm._v(" OK ")])])] : [_vm._t("title"), _vm._t("text"), _c('div', {
    staticClass: "modal__buttons"
  }, [_c('button', {
    staticClass: "modal__button cancel",
    on: {
      "click": function ($event) {
        return _setup.emit('close-modal');
      }
    }
  }, [_vm._v(" キャンセル ")]), _c('button', {
    staticClass: "modal__button ok",
    on: {
      "click": function ($event) {
        return _setup.emit('ok');
      }
    }
  }, [_vm._v("OK")])])]], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };